var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,style:({
    fill: _vm.color
  }),attrs:{"aria-hidden":"true","width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }